import Layout from '@/components/Layout';
import { Button, Stack, Text, Title } from '@mantine/core';
import { IconHome, IconMoodPuzzled } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { Link as RouterLink } from 'react-router-dom';

const NotFoundPage = () => {
  const { t } = useTranslate();
  return (
    <Layout>
      <Stack align="center" gap="lg" py={80} ta="center">
        <IconMoodPuzzled size={120} stroke={1.2} color="var(--mantine-color-dimmed)" />
        <Stack align="center" gap="xs">
          <Title order={1} size="h1">
            {t('notFound.title')}
          </Title>
          <Text c="dimmed" maw={420}>
            {t('notFound.description')}
          </Text>
        </Stack>
        <Button component={RouterLink} to="/" leftSection={<IconHome size={16} />}>
          {t('notFound.back')}
        </Button>
      </Stack>
    </Layout>
  );
};

export default NotFoundPage;
